/**
 * Đổi điểm tích luỹ trên bill — cùng công thức Order::PointRedemption ở backend:
 * trừ sau VAT, giá trị điểm vượt bill thì chỉ dùng đủ số điểm cần.
 */
export interface PointsInput {
  /** Số điểm muốn dùng. */
  points: number;
  /** Giá trị 1 điểm (₫); 0 = tắt đổi điểm. */
  pointValue: number;
  /** Tổng bill trước khi trừ điểm. */
  gross: number;
}

export const applyPoints = ({ points, pointValue, gross }: PointsInput): { pointsUsed: number; discount: number } => {
  if (points <= 0 || pointValue <= 0 || gross <= 0) return { pointsUsed: 0, discount: 0 };

  const pointsUsed = Math.min(Math.floor(points), Math.floor(gross / pointValue));
  return { pointsUsed, discount: Math.round(pointsUsed * pointValue) };
};

/** Giá trị 1 điểm của đơn đã lưu (sửa đơn không có dữ liệu khách từ ô tìm kiếm). */
export const pointValueOf = (
  order: { points_used?: number | string; points_discount_amount?: number | string } | null | undefined,
): number => {
  const used = Number(order?.points_used) || 0;
  return used > 0 ? (Number(order?.points_discount_amount) || 0) / used : 0;
};
